var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"12","md":"6","lg":"6","xl":"6"}},[_c('Postfach_New')],1),_c('v-col',{attrs:{"cols":"12","xs":"12","sm":"12","md":"6","lg":"6","xl":"6"}},[_c('SDSEditor',{attrs:{"new_sds":_vm.new_sds}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }